import { createReducer, on } from '@ngrx/store';
import { Channel } from 'src/app/shared/api/types/GraphQL';
import * as ChannelsActions from './channels.actions';

export interface State {
  channels: Channel[];
  selectedChannels: Channel[];
  loading: boolean;
  mutating: boolean;
  loadedTenantId: number | null;
  /**
   * Whatever the last MUTATION failure carried. Deliberately separate from `loadError`:
   * the channels listing renders `loadError` as its inline "Couldn't load" block, which
   * blanks the rows region — a rejected create/update/delete must never do that to a list
   * that loaded fine (NBO-2341 review).
   */
  error: unknown;
  /** Set only by `loadChannelsFailure`; cleared on every load start and success. */
  loadError: unknown;
}

export const initialState: State = {
  channels: [],
  selectedChannels: [],
  loading: false,
  mutating: false,
  loadedTenantId: null,
  error: null,
  loadError: null
};

export const channelsReducer = createReducer(
  initialState,
  on(ChannelsActions.loadChannels, (state) => ({
    ...state,
    loading: true,
    error: null,
    loadError: null
  })),
  on(ChannelsActions.loadChannelsSuccess, (state, { tenantId, channels }) => ({
    ...state,
    channels: [...channels],
    loadedTenantId: tenantId,
    loading: false,
    error: null,
    loadError: null
  })),
  on(ChannelsActions.loadChannelsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    loadError: error
  })),
  on(ChannelsActions.addChannelToList, (state, { channel }) => ({
    ...state,
    selectedChannels: [...state.selectedChannels, channel]
  })),
  on(ChannelsActions.deleteChannelFromList, (state, { id }) => ({
    ...state,
    selectedChannels: state.selectedChannels.filter((c) => c.id !== id)
  })),
  on(ChannelsActions.clearChannelsList, (state) => ({
    ...state,
    selectedChannels: []
  })),
  on(ChannelsActions.channelCreate, ChannelsActions.channelUpdate, ChannelsActions.channelDelete, (state) => ({
    ...state,
    mutating: true,
    error: null
  })),
  on(
    ChannelsActions.channelCreateSuccess,
    ChannelsActions.channelUpdateSuccess,
    ChannelsActions.channelDeleteSuccess,
    (state) => ({
      ...state,
      mutating: false
    })
  ),
  on(
    ChannelsActions.channelCreateFailure,
    ChannelsActions.channelUpdateFailure,
    ChannelsActions.channelDeleteFailure,
    (state, { error }) => ({
      ...state,
      mutating: false,
      error
    })
  )
);
